import { CountryField } from '../models';

export const countryLabels = {
  [CountryField.Code]: 'Country code',
  [CountryField.Name]: 'Country',
};

export const ALL_COUNTRIES_CODE = '--';
export const ALL_COUNTRIES_LABEL = 'All Countries';
